import './LoadingBtn.less';

export function LoadingBtn(props) {
  const { customFeature, ...rest } = props;
  const {
    loadingStyle,
    loadingImg,
    loadingColor,
    loadingText
  } = customFeature;
  return <div className="common loading-btn" {...rest}>
    {
      loadingStyle == 'img' &&
      <img src={loadingImg} />
    }
    {
      loadingStyle == 'text' &&
      <span style={{
        color: loadingColor
      }}>{loadingText}</span>
    }
  </div>
}


// WEBPACK FOOTER //
// ./src/common/loading-btn/LoadingBtn.jsx